module.exports = __webpack_public_path__ + "img/Sara.b96fcce7.png";